import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('access_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authApi = {
  login: (username: string, password: string) =>
    api.post('/api/auth/token',
      `username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}`,
      { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
    ),

  register: (data: { email: string; company_name: string; phone?: string; password: string }) =>
    api.post('/api/auth/register', data),

  getMe: () => api.get('/api/auth/me'),
};

export const profileApi = {
  generateProfile: (answers: any) => api.post('/api/profiles/generate', answers),
  getCurrentProfile: () => api.get('/api/profiles/current'),
  updateProfile: (data: any) => api.put('/api/profiles/current', data),
  approveProfile: () => api.post('/api/profiles/approve'),
};

export const opportunitiesApi = {
  getMatches: (params?: { days?: number; relevance_tier?: string }) =>
    api.get('/api/opportunities/matches', { params }),

  getMatchDetails: (matchId: number) => api.get(`/api/opportunities/matches/${matchId}`),

  getStats: () => api.get('/api/opportunities/stats'),

  getOpportunities: (params?: {
    limit?: number;
    offset?: number;
    naics_code?: string;
    agency?: string;
    min_value?: number;
    max_value?: number;
  }) => api.get('/api/opportunities', { params }),
};

export const feedbackApi = {
  createFeedback: (data: {
    match_id: number;
    action_type: string;
    ignore_reason?: string;
    notes?: string;
  }) => api.post('/api/feedback', data),

  getUserFeedback: (userId: number) => api.get(`/api/feedback/user/${userId}`),
};

export default api;